<template>
  <div class="accounts-list">
    <v-list v-if="folders" class="pb-0 pt-0" light>
      <template v-for="folder in sortedFolders">
        <account :folder="folder" :edit-mode="editMode" :key="folder.id" />
        <v-divider class="accounts-list__divider" />
      </template>
    </v-list>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Account from './Account'

  export default {
    data () {
      return {
        editMode: false
      }
    },
    computed: {
      ...mapGetters('user', ['isLoggedIn']),
      ...mapState('folders', ['folders']),
      sortedFolders () {
        // Sort alphabetically
        return this.folders.sort(function (first, second) {
          let a = first.provider.name.toLowerCase()
          let b = second.provider.name.toLowerCase()
          if (a === b) {
            return 0
          }
          if (typeof a === typeof b) {
            return a < b ? -1 : 1
          }
          return typeof a < typeof b ? -1 : 1
        })
      }
    },
    methods: {
      getFolders () {
        if (this.isLoggedIn) {
          this.$store.dispatch('folders/getFolders')
        }
      }
    },
    mounted () {
      if (this.folders == null) {
        this.getFolders()
      }
    },
    components: {
      Account
    }
  }
</script>

<style lang="stylus">
  @import '~styles/bonsai/_settings.styl'

  .accounts-list
    &__divider
      background: $material-light.dividers !important
</style>



// WEBPACK FOOTER //
// frontend/src/components/list/Accounts.vue